import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="protected-loading"
        className="flex-grow flex items-center justify-center py-20"
      >
        <p className="font-display text-base uppercase tracking-widest">
          <span className="blink">▮</span> CHECKING CREDENTIALS...
        </p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
}
